import { useCallback, useState } from "react";
import { LabeledInput } from "../../../../Components/ConfigurationTab/LabeledInput";
import { useFormikContext } from "formik";
import { ConfigTabState } from "../../types";
import dayjs from "dayjs";

const MinutesFromNowInput = (props: {
  fieldKey: string;
  endBeforeStartError?: boolean;
  disabled?: boolean;
}) => {
  const { values, setFieldValue } = useFormikContext<ConfigTabState>();
  const dateValue: dayjs.Dayjs = values[
    props.fieldKey as keyof ConfigTabState
  ] as dayjs.Dayjs;
  const [isFocused, setIsFocused] = useState(false);

  const setDateValue = (value: undefined | dayjs.Dayjs) => {
    setFieldValue(props.fieldKey, value);
  };

  const get_display_value = useCallback(() => {
    if (dateValue === undefined) {
      return undefined;
    }

    const displayValue = dateValue.diff(dayjs(), "second") / 60;
    if (isFocused) {
      // user is currently editing the value as a whole number. We just round to ensure that.
      return Math.round(displayValue);
    } else {
      // the value is is rounded up to always show the next minute
      // this is to avoid values between 0 and 1 to be represented as 0
      return Math.ceil(displayValue);
    }
    // isFocused is not inclued as it causes the value to bounce
    // eslint-disable-next-line
  }, [dateValue]);

  return (
    <LabeledInput
      label="From now"
      disabled={props.disabled}
      error={props.endBeforeStartError}
      placeholder="Minutes"
      name="minutes_from_now"
      type="number"
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      onChange={(e) => {
        try {
          const offset = Number(e.target.value);
          const newDate = dayjs().add(offset, "minute");

          setDateValue(newDate);
        } catch (e) {
          console.error(e);
        }
      }}
      value={get_display_value()}
    />
  );
};

export { MinutesFromNowInput };
